import styled from '@emotion/styled';
import { TableCell } from '@kc-console/common-ui';
import { np } from '@kc-console/core';

import type { DataTableColumnVirtualizationSpacer } from './types';

export interface DataTableColumnVirtualizationSpacerCellProps {
  spacer: DataTableColumnVirtualizationSpacer;
}

/** 화면 밖 중앙 컬럼의 너비와 논리 컬럼 수를 보존하는 빈 셀을 렌더링 */
export default function DataTableColumnVirtualizationSpacerCell({
  spacer,
}: DataTableColumnVirtualizationSpacerCellProps) {
  return <SpacerCell aria-hidden colSpan={spacer.colSpan} $width={spacer.width} />;
}

const SpacerCell = styled(TableCell, {
  shouldForwardProp: np('$width'),
})<{ $width: number }>`
  && {
    box-sizing: border-box;
    max-width: ${({ $width }) => `${$width}px`};
    min-width: ${({ $width }) => `${$width}px`};
    padding: 0;
    width: ${({ $width }) => `${$width}px`};
  }
`;
